import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import { useVyNavigate } from '../../../../../hooks/use-vy-navigate';

type UpdateContractDialogProps = {
  contractId: string;
  isDialogOpen: boolean;
  handleClose: () => void;
  isEditable: boolean;
};

export const UpdateContractDialog: React.FC<UpdateContractDialogProps> = ({
  contractId,
  isDialogOpen,
  handleClose,
  isEditable,
}) => {
  const navigate = useVyNavigate();

  const handleDialogSubmit = () => {
    navigate(`/plans/contracts/${contractId}/update`);
    handleClose();
  };

  return (
    <VyDialog
      open={isDialogOpen}
      onClose={handleClose}
      label="Contract Edit"
      labelDescription="Modify the contract to fix errors that arose during contract creation."
      warningText={
        isEditable
          ? 'Use this function only if the current invoice has not yet been issued or approved. Changes will apply to all open invoices and will not affect previously approved invoices.'
          : 'This contract cannot be edited because an invoice has already been issued or approved.'
      }
      cancelButtonText="Cancel"
      ctaDisabled={!isEditable}
      ctaText="Continue"
      onSubmit={handleDialogSubmit}
    />
  );
};
